<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <PrimeDialog
    :visible="modelValue"
    :modal="true"
    :dismissableMask="true"
    :closeOnEscape="true"
    :style="{ width: '90vw', height: '90vh' }"
    :contentStyle="{ height: 'calc(100% - 60px)', padding: 0 }"
    @update:visible="$emit('update:modelValue', $event)"
  >
    <template #header>
      <div class="dialog-header">
        <i class="ri-braces-line"></i>
        <span>{{ title || $t("dashboardAdmin.blockEditor.editJson") }}</span>
      </div>
    </template>
    <CodeMirrorBase v-model="localContent" language="json" />
    <template #footer>
      <PrimeButton
        :label="$t('cancel')"
        icon="ri-close-line"
        text
        @click="handleCancel"
      />
      <PrimeButton
        :label="$t('dashboardAdmin.blockEditor.apply')"
        icon="ri-check-line"
        @click="handleSave"
      />
    </template>
  </PrimeDialog>
</template>

<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import CodeMirrorBase from "@/components/CodeMirrorBase.vue";

export default {
  name: "JsonEditorDialog",
  components: {
    PrimeDialog: Dialog,
    PrimeButton: Button,
    CodeMirrorBase,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  emits: ["update:modelValue", "save", "cancel"],
  data() {
    return {
      localContent: this.content,
    };
  },
  watch: {
    content(newValue) {
      this.localContent = newValue;
    },
    modelValue(newValue) {
      if (newValue) {
        this.localContent = this.content;
      }
    },
  },
  methods: {
    handleSave() {
      // Validate JSON before saving
      try {
        JSON.parse(this.localContent);
        this.$emit("save", this.localContent);
        this.$emit("update:modelValue", false);
      } catch (error) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("dashboardAdmin.blockEditor.invalidJson"),
          life: 3000,
        });
      }
    },
    handleCancel() {
      this.localContent = this.content;
      this.$emit("cancel");
      this.$emit("update:modelValue", false);
    },
  },
};
</script>

<style scoped>
.dialog-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
